import React from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const bootstrap = getBootstrap();
const bootstrapUser = bootstrap.get('user');

export const UserContext = React.createContext(bootstrapUser);

export function withUser(Component) {
    return function ComponentWithUser(props) {
        return <UserContext.Consumer>{(user) => <Component {...props} user={user} />}</UserContext.Consumer>;
    };
}
